import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CategoryService } from './category.service';
import { fuseAnimations } from '../../../../core/animations';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Subscription } from 'rxjs/Subscription';
import { Category } from './category.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseUtils } from '../../../../core/fuseUtils';
import { MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { CategoriesService } from '../categories/categories.service';
import { Router } from '@angular/router';

@Component({
    selector     : 'fuse-category',
    templateUrl  : './category.component.html',
    styleUrls    : ['./category.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class CategoryComponent implements OnInit, OnDestroy
{
    category = new Category();
    categories: any;
    onCategoryChanged: Subscription;
    pageType: string;
    productForm: FormGroup;
    fileToUpload: File = null;
    fileLargeToUpload: File = null;

    constructor(
        private categoryService: CategoryService,
        private categoriesService: CategoriesService,
        private formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private location: Location,
        private router: Router,
    ) {}

    ngOnInit()
    {
        this.categoriesService.getParents().then((response) => {
            this.categories = response;

            // Subscribe to update category on changes
            this.onCategoryChanged =
                this.categoryService.onCategoryChanged
                    .subscribe(category => {
                        if ( category )
                        {
                            this.category = new Category(category);
                            this.pageType = 'edit';
                        }
                        else
                        {
                            this.pageType = 'new';
                            this.category = new Category();
                        }

                        this.productForm = this.createProductForm();
                    });
        });
    }

    back() {
        if (this.category.parentCategory) {
            this.router.navigate(['/categories', this.category.parentCategory]);
        } else {
            this.router.navigate(['/categories']);
        }
    }

    createProductForm()
    {
        return this.formBuilder.group({
            id             : [this.category._id],
            title          : [this.category.title, Validators.required],
            description    : [this.category.description],
            title_en       : [this.category.title_en, Validators.required],
            description_en : [this.category.description_en],
            image          : [this.category.image],
            imageLarge     : [this.category.imageLarge],
            parentCategory : [this.category.parentCategory],
            disabled       : [this.category.disabled],
        });
    }

    handleFileInput(files: FileList) {
        this.fileToUpload = files.item(0);
        this.uploadFileToActivity();
    }

    private uploadFileToActivity() {
        this.categoryService.postImage(this.category._id, this.fileToUpload).subscribe(data => {
            this.uploadFileSuccess(data);
        }, error => {
            console.log(error);
        });
    }

    handleFileLargeInput(files: FileList) {
        this.fileToUpload = files.item(0);
        this.uploadFileLargeToActivity();
    }

    private uploadFileLargeToActivity() {
        this.categoryService.postImageLarge(this.category._id, this.fileToUpload).subscribe(data => {
            this.uploadFileSuccess(data);
        }, error => {
            console.log(error);
        });
    }

    deleteImage() {
        this.categoryService.deleteImage(this.category._id).subscribe(() => {
            this.deleteFileSuccess();
        }, error => {
            console.log(error);
        });
    }
    deleteImageLarge() {
        this.categoryService.deleteImageLarge(this.category._id).subscribe(() => {
            this.deleteFileSuccess();
        }, error => {
            console.log(error);
        });
    }

    private uploadFileSuccess(data) {
        // console.log(data);
        this.snackBar.open('Image sauvegardée', 'OK', {
            verticalPosition: 'top',
            duration        : 2000
        });
        this.categoryService.getCategory();
    }

    private deleteFileSuccess() {
        // console.log(data);
        this.snackBar.open('Image supprimée', 'OK', {
            verticalPosition: 'top',
            duration        : 2000
        });
        this.categoryService.getCategory();
    }

    saveProduct()
    {
        const data = this.productForm.getRawValue();
        // data.handle = FuseUtils.handleize(data.name);
        this.categoryService.saveCategory(data)
            .then(() => {
                // Trigger the subscription with new data
                this.categoryService.onCategoryChanged.next(data);
                // Show the success message
                this.snackBar.open('Category saved', 'OK', {
                    verticalPosition: 'top',
                    duration        : 2000
                });
            })
            .catch(e => {
                this.snackBar.open('Une erreur est survenue', 'OK', {
                    verticalPosition: 'bottom',
                    duration        : 2000
                });
            });
    }

    addProduct()
    {
        const data = this.productForm.getRawValue();
        // data.handle = FuseUtils.handleize(data.name);
        this.categoryService.addCategory(data)
            .then((response) => {

                // Trigger the subscription with new data
                this.categoryService.onCategoryChanged.next(data);

                // Show the success message
                this.snackBar.open('Category added', 'OK', {
                    verticalPosition: 'top',
                    duration        : 2000
                });

                // Change the location with new one
                this.location.go('category/' + response._id);
            })
            .catch(e => {
                this.snackBar.open('Une erreur est survenue', 'OK', {
                    verticalPosition: 'bottom',
                    duration        : 2000
                });
            });
    }

    ngOnDestroy()
    {
        this.onCategoryChanged.unsubscribe();
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/category/category.component.ts